import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { SearchStateType, SearchStateTypeWithDates } from "../../../Orchestrator/Types/Index";
import dayjs from "dayjs";

export class OutboundInboundDateAction extends BaseAction<Partial<SearchStateType>, SearchStateTypeWithDates> {
    isDateChanged = (currentDate?: string, newDate?: string): boolean => {
        let isCurrentDateToday = false;
        let isNewDateToday = false;

        if (currentDate) {
            isCurrentDateToday = dayjs(currentDate).isSame(dayjs(), "day");
        }
        if (newDate) {
            isNewDateToday = dayjs(newDate).isSame(dayjs(), "day");
        }
        return isCurrentDateToday !== isNewDateToday;
    }

    override async run(): Promise<Partial<SearchStateType>> {
        let searchData: Partial<SearchStateType> = {}
        try {
            const { dates, search, isFromPopUp, searchPopup } = this.params!;
            const [startDate, endDate] = dates;

            let isOutboundDateChanged = false;
            if (isFromPopUp) {
                updateRecoilState("searchStatePopupAtom", {
                    ...searchPopup,
                    outboundDate: startDate,
                    inboundDate: endDate
                });

                if (search?.outboundDate) {
                    isOutboundDateChanged = this.isDateChanged(searchPopup?.outboundDate?.toISOString(), startDate);
                }
            }
            else {
                const modifiedData = {
                    ...search,
                    outboundDate: startDate,
                    inboundDate: endDate
                }
                updateRecoilState("searchStateAtom", modifiedData);
                searchData = modifiedData

                if (search?.outboundDate) {
                    isOutboundDateChanged = this.isDateChanged(search?.outboundDate.toISOString(), startDate);
                }
            }

            setTimeout(() => {
                updateRecoilState("isDepartureDateChangedAtom", isOutboundDateChanged);
            }, 100)
        } catch (error) {
            console.error("Error in OutboundInboundDateAction:", error);
        } finally {
            return searchData
        }
    }
}

// Create a singleton instance
export const outboundInboundDateAction = new OutboundInboundDateAction(); 